import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "./AdPopup.css"; // custom styles
import adImage from "../assets/images/wfot2.png"; // replace with your image

const AdPopup = () => {
  const [showAd, setShowAd] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/") {
      setTimeout(() => {
        setShowAd(true); // show after 1 sec
      }, 1000);
    }
  }, []);

  if (!showAd) return null;

  return (
    <div className="ad-popup">
      <div className="ad-content">
        <Button
          variant="light"
          className="close-btn"
          onClick={() => setShowAd(false)}
        >
          X
        </Button>
        <img src={adImage} alt="Ad Banner" className="ad-image" />
      </div>
    </div>
  );
};

export default AdPopup;
